import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=10e66283&scoped=true&"
import script from "./NotificationContent.vue?vue&type=script&lang=js&"
export * from "./NotificationContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=10e66283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e66283",
  null
  
)

export default component.exports